/**
* Method to deal with issues of vselect 3 that errors out if the options length is greater than 180.
* ERROR: error is to do with duplicated keys due to how vselect3 loops through the array of options
* @param data the data we want to slice and return to keep the limit cap at 180
* @param limit the limiting factor that can be overridden if required, default 180
 */
function maxData(data: any[], limit: number = 180): any[] {
    if (!data || data.length == 0) return [];
    return data.slice(0, limit);
}

/**
* Method to detect if we need to query locally on our current array or if we need to query.
* @param data.length the data length we want to check
* @param limit the limiting factor that can be overridden if required, default 180
* @param overrideSearchResult If you have custom logic and want to override the result.
* set desired return true/false values.
 */
function isInternalSearch(data: any[], limit: number = 180, overrideSearchResult: boolean = null): boolean {
    if (!data || data.length == 0) return true;
    if (overrideSearchResult !== null) return overrideSearchResult;
    if(data.length < limit) return true;
    return false;
}

export { maxData, isInternalSearch };
